import React from "react";
import { Card, Text, XStack, YStack } from "tamagui";

interface SensorEventCardProps {
  latestSensorEvent: any;
  formatTimestamp: (timestamp: number | null | undefined) => string;
  parseJsonSafely: (value: any) => any;
}

export const SensorEventCard: React.FC<SensorEventCardProps> = ({
  latestSensorEvent,
  formatTimestamp,
  parseJsonSafely,
}) => {
  if (!latestSensorEvent) {
    return null;
  }

  return (
    <YStack>
      <XStack
        justifyContent="space-between"
        alignItems="center"
        marginBottom="$2"
      >
        <Text fontWeight="bold">Latest Sensor Event:</Text>
        <XStack space="$2" alignItems="center">
          <Text opacity={0.7} fontSize="$2">
            {formatTimestamp(latestSensorEvent.timestamp)} |{" "}
            {latestSensorEvent.eventType}
          </Text>
        </XStack>
      </XStack>

      <Card
        padding="$3"
        backgroundColor="$background"
        borderWidth={1}
        borderColor="$borderColor"
      >
        <XStack flexDirection="row" flexWrap="wrap">
          {/* Values from parsed JSON - Left side */}
          {latestSensorEvent.values && (
            <YStack space="$1" flex={1} minWidth={200} paddingRight="$2">
              <Text fontWeight="bold" fontSize="$3">
                Values
              </Text>
              <XStack flexWrap="wrap">
                {Object.entries(parseJsonSafely(latestSensorEvent.values)).map(
                  ([key, value]) => (
                    <XStack
                      key={key}
                      space="$1"
                      marginRight="$4"
                      marginBottom="$2"
                      minWidth={140}
                    >
                      <Text fontWeight="bold" fontSize="$2">
                        {key}:
                      </Text>
                      <Text fontSize="$2">{String(value)}</Text>
                    </XStack>
                  ),
                )}
              </XStack>
            </YStack>
          )}

          {/* Metadata from parsed JSON - Right side */}
          {latestSensorEvent.metadata && (
            <YStack space="$1" flex={1} minWidth={200}>
              <Text fontWeight="bold" fontSize="$3">
                Metadata
              </Text>
              <XStack flexWrap="wrap">
                {Object.entries(
                  parseJsonSafely(latestSensorEvent.metadata),
                ).map(([key, value]) => (
                  <XStack
                    key={key}
                    space="$1"
                    marginRight="$4"
                    marginBottom="$2"
                    minWidth={140}
                  >
                    <Text fontWeight="bold" fontSize="$2">
                      {key}:
                    </Text>
                    <Text fontSize="$2">{String(value)}</Text>
                  </XStack>
                ))}
              </XStack>
            </YStack>
          )}
        </XStack>
      </Card>
    </YStack>
  );
};
